export function compareNullableNumbers(
  a: number | null | undefined,
  b: number | null | undefined
): number {
  return (a ?? 0) - (b ?? 0)
}
